import moment from 'moment';
import { orgGuidPayouts, orgGuidPayoutsCount, orgGuPayoutsMoreData } from '../../../../../api/orgGuidAPI';
import errorHandle from '../../../../../utils/errorHandle';

export const fetchGuidPayoutsCount = async (setTotalCount, setLoading) => {
    setLoading(true);
    try {
        const response = await orgGuidPayoutsCount();
        setTotalCount(response?.data?.payoutsCount);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchGuidPayoutsData = async (limit, offset, setPayoutData, setLoading) => {
    setLoading(true);
    try {
        const payoutData = await orgGuidPayouts(limit, offset);
        const includeDates =
            payoutData.data.length > 0
                ? payoutData?.data?.map((item) => {
                      const date = moment(item.payoutDate, 'YYYY-MM-DD');
                      let subtractDays = null;
                      if (date.day() === 1) {
                          subtractDays = 3;
                      } else if (date.day() === 5) {
                          subtractDays = 4;
                      }
                      const fromDate =
                          subtractDays !== null ? date.clone().subtract(subtractDays, 'days').format() : null;
                      const toDate = date.clone().subtract(1, 'days').format();
                      return {
                          ...item,
                          fromDate,
                          toDate
                      };
                  })
                : [];
        setPayoutData(includeDates);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};

export const fetchMoreDetails = async (id, setMoreDetails, setLoading) => {
    setLoading(true);
    try {
        const payoutData = await orgGuPayoutsMoreData(id);
        setMoreDetails(payoutData.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};
